module.exports = __webpack_public_path__ + "static/media/7.1.c3a0298a.png";